/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function ITConsulting() {
  return (
    <>
      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Our IT Consulting Services
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            Strategic advisory and hands-on expertise to help you make confident technology decisions.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Technology Roadmaps
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Clear long-term planning to guide your IT investments and support your business goals.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Digital Transformation
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Move from outdated systems to modern, efficient, cloud-ready environments.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                IT Budget Planning
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Align technology spending with your business objectives and reduce unexpected costs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why IT Consulting Matters"
        subtitle="Expert guidance helps you align technology decisions with long-term business outcomes."
        benefits={[
          {
            id: "optimize-tech",
            title: "Optimize Your Technology",
            text: "Identify inefficiencies and improve performance across your IT ecosystem.",
            delay: 0,
          },
          {
            id: "accelerate-growth",
            title: "Accelerate Business Growth",
            text: "Use technology to modernize workflows, improve scalability, and drive innovation.",
            delay: 120,
          },
          {
            id: "reduce-risk",
            title: "Reduce IT Risks",
            text: "Ensure your systems are secure, reliable, and ready for the future.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "decisions", text: "Better IT decision-making" },
          { id: "security", text: "Stronger security & stability" },
          { id: "costs", text: "Lower long-term IT costs" },
          { id: "advantage", text: "A strategic competitive advantage" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Need Smart IT Guidance?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let our experts help you plan, modernize and transform your technology.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
